import { render, staticRenderFns } from "./PublishResultReportForm.vue?vue&type=template&id=996eb260&"
import script from "./PublishResultReportForm.vue?vue&type=script&lang=ts&"
export * from "./PublishResultReportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports